import Modal from "@/components/Modal";
import { RATE_CATEGORY } from "@/constants/project-constant";
import { voteCategoryColor } from "@/utils";
import { ProjectReview } from "Models";
import { Progress } from "antd";
import clsx from "clsx";
import { useContext, useEffect, useMemo, useState } from "react";
import FileMedia from "./FileMedia";
import { ProjectContext } from "@/context/project.context";
import ProjectVideoBox from "./ProjectVideoBox";
import Link from "next/link";
import { APP_MEEYPROJECT_URL } from "@/constants/environment";

interface IHeaderProjectInfo {
  project: ProjectReview;
}
const RightContent = ({ project }: IHeaderProjectInfo) => {
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [isShowMore, setIsShowMore] = useState(false);
  const { projectVideos } = useContext(ProjectContext);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      const projectDes = document.getElementById("project-description");
      setIsShowMore(projectDes?.offsetHeight > 275);
    }
  }, [mounted, project]);

  const isShowVoteScore = useMemo(() => {
    const isHasScore = project?.votes?.find((vote) => vote.score > 0);
    if (isHasScore) {
      return true;
    }
    return false;
  }, [project?.votes]);

  return (
    <div className="flex flex-col gap-6 flex-[0_0_19.5rem]">
      {
        <>
          {/* mô tả */}
          {projectVideos?.length ? (
            <ProjectVideoBox />
          ) : project?.description ? (
            <div className="bg-white rounded-lg p-3 shadow-light-1">
              <span className="text-grey-500 text-fs-14 font-medium">
                VỀ DỰ ÁN
              </span>
              <hr className="my-2" />
              <div
                className="text-fs-14 text-grey-700 overflow-hidden"
                id="project-description">
                <div
                  className={clsx(
                    "text-ellipsis break-words whitespace-pre-line",
                    isShowMore ? "max-h-[260px] overflow-hidden" : ""
                  )}
                  dangerouslySetInnerHTML={{
                    __html: project?.description,
                  }}></div>
                {isShowMore ? (
                  <div>
                    <span>... </span>
                    <Link
                      href={
                        APP_MEEYPROJECT_URL +
                        "/project/" +
                        project.slug +
                        "-" +
                        project.shortId
                      }
                      target="_blank"
                      className="text-blue-500 cursor-pointer">
                      xem thêm
                    </Link>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          ) : null}

          {/* tiêu chí đánh giá */}
          {isShowVoteScore ? (
            <div className="bg-white rounded-lg p-3 shadow-light-1">
              <span className="text-grey-500 text-fs-14 font-medium">
                TIÊU CHÍ ĐÁNH GIÁ
              </span>
              <hr className="my-2" />
              <div className="flex flex-col gap-3">
                {project?.votes && project?.votes?.length
                  ? project?.votes.map((vote: any) => {
                      const label = RATE_CATEGORY.find(
                        (rate) => rate.key == vote.voteCategory
                      )?.title;

                      return (
                        <div
                          className="flex items-center gap-3 justify-between"
                          key={vote.voteCategory}>
                          <span className="text-grey-700 font-medium text-fs-14 w-[80px] shrink-0">
                            {label}
                          </span>
                          <Progress
                            percent={vote?.score * 2 * 10}
                            showInfo={false}
                            strokeColor={{
                              "0%": voteCategoryColor(vote?.score),
                              "100%": voteCategoryColor(vote?.score),
                            }}
                            className="mb-0 mr-0"
                          />
                          <span className="text-grey-700 text-fs-14 font-medium whitespace-nowrap">
                            {Number.isInteger(vote?.score)
                              ? vote?.score
                              : vote?.score?.toFixed(1)}
                            /5
                          </span>
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* file phương tiện */}
          <FileMedia />
        </>
      }

      <Modal
        open={openModalInfo}
        onClose={() => setOpenModalInfo(false)}
        footerClassName="border-none !p-0"
        contentClassName="w-[40rem]"
        bodyClassName="!pt-3 !px-6 !pb-6"
        header={
          <div className="flex items-center gap-2 text-blue-500">
            <i className="mrv mrv-info text-fs-24"></i>
            <span className="text-fs-20 font-semibold">Về dự án</span>
          </div>
        }>
        <div className="max-h-[250px] overflow-y-auto text-fs-14 text-grey-700 whitespace-pre-line">
          {project?.description}
        </div>
      </Modal>
    </div>
  );
};

export default RightContent;
